/* RK: MAATADVISEUR - LOGICA.
   Dit bestand stond tot nu toe als tweede inline <script> in
   sections/rk-sizeguide.liquid. Het is hier NIET gewijzigd, alleen verplaatst:
   de inhoud is byte voor byte dezelfde als het oude blok.

   WAAROM VERPLAATST: de theme-editor rendert de sectie bij elke aanpassing
   opnieuw via de Section Rendering API. Daarbij ging ~34 KB script telkens
   opnieuw over de lijn EN opnieuw door de parser. Bij het bewerken van de
   maattabellen - precies wat hier het vaakst gebeurt - werd de editor daar
   traag en schokkerig van. Als los bestand haalt de browser dit een keer op,
   cachet het, en blijft er bij een heruitvoering alleen het kleine
   Liquid-blok over.

   HOE HET VERS BLIJFT: het inline blok in de sectie zet bij elke
   heruitvoering een NIEUW window.RK_SG_DATA neer en tikt daarna
   window.__rkSizeguideInit() aan. Dit bestand draait zelf maar een keer
   (het is immers gecached), maar het haakje hieronder vangt die verse
   gegevens op, zodat de preview meebeweegt. Draait dit bestand nog niet op
   het moment dat het inline blok zijn seintje wil geven - de eerste keer
   laden, want dit bestand is `defer` - dan is dat geen probleem: de eerste
   regel hieronder leest window.RK_SG_DATA gewoon zelf uit.

   LET OP: dit is een statisch .js-bestand, hier wordt GEEN Liquid meer
   verwerkt. Zet er dus nooit {{ ... }} of {% ... %} in. */

  (() => {
    /* Op let en niet op const: het blok hierboven zet window.RK_SG_DATA bij
       elke heruitvoering opnieuw neer als een NIEUW object. De kopie die al
       draait moet dus naar dat verse object kunnen wijzen, anders blijft ze
       met de oude instellingen werken. */
    let D = window.RK_SG_DATA;
    if (!D) return;

    /* RK: RE-ENTRY. Deze sectie staat in een groep die op elke pagina laadt,
       en de theme-editor voert het script van een sectie bij ELKE wijziging
       opnieuw uit (shopify:section:load) zonder de vorige kopie te stoppen.
       Zonder rem stapelen de klikluisteraar, de change-luisteraar en de
       waarnemer op de rechterkolom zich op - na twintig wijzigingen twintig
       stuks, en de editor loopt vast.

       Een kale `return` mag hier NIET: dit script leest de SKU-lijst, de
       maattabellen, de adviseurteksten en de koppen uit de instellingen, en
       dan zou de preview geen enkele wijziging meer tonen. Daarom dezelfde
       aanpak als __rkSgStyle in sections/rk-sg-style.liquid: we bewaren een
       HAAKJE. De nieuwe kopie geeft haar verse gegevens door aan de kopie
       die al draait en houdt er dan mee op. Zo blijft het bij een
       luisteraar, en zie je een gewijzigde tekst toch meteen terug. */
    if (window.__rkSizeguideInit) {
      window.__rkSizeguideInit(D);
      return;
    }

    /* Alles wat bij het opstarten uit D is afgeleid, wordt hier opnieuw
       afgeleid - de rest van de code leest D verderop toch al per keer uit.
       Dit haakje hangt niets nieuws op: geen waarnemer, geen luisteraar,
       geen tijdklopje. De link en de adviseurknop worden weggehaald en
       opnieuw geplaatst, want hun opschrift komt uit de instellingen;
       ensureLink() zet ze precies zo terug als bij het opstarten. */
    window.__rkSizeguideInit = (data) => {
      if (!data) return;
      D = data;
      Object.keys(parsed).forEach((k) => { delete parsed[k]; });
      Object.keys(D.guides).forEach((k) => { parsed[k] = parse(D.guides[k].data); });
      advBands = parseWeightBands(D.advisor && D.advisor.weightTable);
      advRunsLarge = String((D.advisor && D.advisor.runsLarge) || '')
        .split(/[\n,]+/).map((s) => s.trim().toLowerCase()).filter(Boolean);
      advTall = parseFloat(D.advisor && D.advisor.tall) || 0;
      titles = String(D.text.guideTitles || 'size guide')
        .toLowerCase().split(',').map((x) => x.trim()).filter(Boolean);
      document.querySelectorAll('.rk-sg-link, .rk-sg-advisor-btn').forEach((el) => el.remove());
      ensureLink();
    };

    /* Alleen deze rijen zijn centimeters en gaan mee in de inch-omrekening.
       Een rij als "EU size" blijft dus gewoon 110, 116, 128 staan. De drie
       broekrijen staan er expliciet bij - zie kop-comment. */
    const CM_ROWS = ['chest', 'shoulder', 'length', 'sleeve', 'outseam', 'waist', 'hip'];

    /* XXL en 2XL zijn hetzelfde; je leverancier schrijft het niet overal gelijk. */
    const norm = (s) => String(s || '').trim().toUpperCase()
      .replace(/^2XL$/, 'XXL').replace(/^3XL$/, 'XXXL').replace(/\s+/g, '');

    function parse(txt) {
      const out = { sizes: [], rows: {}, order: [], labels: {}, fit: '' };
      String(txt || '').split(/\r?\n/).forEach((line) => {
        const m = line.split(':');
        if (m.length < 2) return;
        const raw = m[0].trim();
        const key = raw.toLowerCase();
        const rest = m.slice(1).join(':').trim();
        if (!raw || !rest) return;
        if (key === 'fit' || key === 'pasvorm') { out.fit = rest; return; }
        const vals = rest.split(',').map((v) => v.trim()).filter(Boolean);
        if (!vals.length) return;
        if (key === 'sizes' || key === 'maten') { out.sizes = vals; return; }
        if (out.order.indexOf(key) === -1) out.order.push(key);
        out.rows[key] = vals;
        out.labels[key] = raw;
      });
      return out;
    }

    /* Adviseur: gewichtsladder per maat, regels als "S: 60-70". Wordt net zo
       ingelezen als de bestaande maatvelden hierboven: eenvoudig op tekst. */
    function parseWeightBands(txt) {
      const out = [];
      String(txt || '').split(/\r?\n/).forEach((line) => {
        const idx = line.indexOf(':');
        if (idx === -1) return;
        const key = line.slice(0, idx).trim();
        const rest = line.slice(idx + 1).trim();
        const m = rest.match(/(-?[\d.,]+)\s*-\s*(-?[\d.,]+)/);
        if (!key || !m) return;
        const min = parseFloat(m[1].replace(',', '.'));
        const max = parseFloat(m[2].replace(',', '.'));
        if (isNaN(min) || isNaN(max)) return;
        out.push({ key: key, min: min, max: max });
      });
      return out;
    }

    /* Vult [token]'s in een instelling-tekst in met platte waarden.
       De oude {{token}}-schrijfwijze blijft ook werken. */
    function fill(tmpl, map) {
      let out = String(tmpl || '');
      Object.keys(map).forEach((k) => {
        const re = new RegExp('\\[\\s*' + k + '\\s*\\]|\\{\\{\\s*' + k + '\\s*\\}\\}', 'g');
        out = out.replace(re, () => map[k]);
      });
      return out;
    }

    function pickBandIndex(bands, w) {
      for (let i = 0; i < bands.length; i++) {
        if (w >= bands[i].min && w <= bands[i].max) return i;
      }
      if (w < bands[0].min) return 0;
      if (w > bands[bands.length - 1].max) return bands.length - 1;
      let best = 0, bestDist = Infinity;
      bands.forEach((b, i) => {
        const d = w < b.min ? b.min - w : w - b.max;
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    /* De rekenregel. Belangrijk: de gewichtsladder bepaalt WELKE MAATNAAM
       eruit komt, niet welke plek in een rijtje. Die naam zoeken we daarna op
       in de maten die dit kledingstuk echt heeft en echt verkoopt. Zo kan XS
       er wel uitkomen op een faded tee of een zip hoodie (die hebben XS), en
       nooit op een gewone tee (die heeft hem niet) - vroeger stond het rijtje
       vast op S t/m XXL en was XS dus onbereikbaar.

       Daarna tellen we er een maat bij op als de klant boven de lengte-grens
       zit of ruim wil, en halen we er een af bij strak of bij een kledingstuk
       dat groter uitvalt (runs_large). Die stappen lopen door de maten van
       DIT kledingstuk, dus we kunnen nooit buiten zijn eigen rijtje komen.
       Val je buiten de ladder, dan kappen we af op de rand (clampLow/
       clampHigh) en dat wordt eerlijk gemeld.

       !! EEN MAAT, NOOIT TWEE !!
       Zit iemand binnen 2 kg van een grens, dan kwam er vroeger M / L of
       S / M uit. Twee maten is geen advies - dan staat de klant nog steeds
       te kiezen, en dat is precies waarvoor hij hier klikte. We kijken nog
       steeds of hij tussen twee maten in zit, maar geven dan de GROOTSTE
       van de twee. Te ruim draag je nog; te klein niet, en dat wordt een
       retour. straddleSize blijft daarom altijd leeg. */
    function computeAdvice(heightCm, weightKg, fit) {
      if (!advBands.length || !(weightKg > 0) || !(heightCm > 0)) return null;

      const listRaw = advSizeListRaw();
      if (!listRaw.length) return null;
      const list = listRaw.map(norm);

      /* Ladder-index -> plek in het rijtje van dit kledingstuk, op naam. */
      const at = (bandIdx) => {
        if (bandIdx < 0 || bandIdx > advBands.length - 1) return -1;
        return list.indexOf(norm(advBands[bandIdx].key));
      };

      const bandIdx = pickBandIndex(advBands, weightKg);
      let baseIdx = at(bandIdx);
      if (baseIdx === -1) {
        /* De maat uit de ladder verkoopt dit product niet. Loop dan naar
           buiten tot we een laddermaat vinden die er wel is. Vinden we er
           helemaal geen - kindermaten in leeftijden bijvoorbeeld - dan geven
           we liever niets terug dan een maat die niet bestaat. */
        for (let d = 1; d < advBands.length; d++) {
          const lo = at(bandIdx - d);
          if (lo > -1) { baseIdx = lo; break; }
          const hi = at(bandIdx + d);
          if (hi > -1) { baseIdx = hi; break; }
        }
        if (baseIdx === -1) return null;
      }

      let straddleNeighbor = null;
      if (bandIdx > 0 && Math.abs(weightKg - advBands[bandIdx].min) <= 2) straddleNeighbor = at(bandIdx - 1);
      if (bandIdx < advBands.length - 1 && Math.abs(weightKg - advBands[bandIdx].max) <= 2) straddleNeighbor = at(bandIdx + 1);

      let adj = 0, tallApplied = false, largeApplied = false;
      if (advTall > 0 && heightCm >= advTall) { adj += 1; tallApplied = true; }
      if (fit === 'tight') adj -= 1;
      else if (fit === 'loose') adj += 1;
      if (advRunsLarge.indexOf(garment()) > -1) { adj -= 1; largeApplied = true; }

      /* Eerlijk melden zodra het gewicht zelf al buiten de tabel valt, ook
         als een correctie de uitkomst toevallig weer terugtrekt binnen de
         rand. */
      let clampLow = weightKg < advBands[0].min;
      let clampHigh = weightKg > advBands[advBands.length - 1].max;

      let finalIdx = baseIdx + adj;
      if (finalIdx < 0) { finalIdx = 0; clampLow = true; }
      if (finalIdx > list.length - 1) { finalIdx = list.length - 1; clampHigh = true; }

      /* Tussen twee maten in: de grootste wint - zie de uitleg hierboven. */
      if (straddleNeighbor !== null && straddleNeighbor > -1) {
        let sIdx = straddleNeighbor + adj;
        if (sIdx < 0) sIdx = 0;
        if (sIdx > list.length - 1) sIdx = list.length - 1;
        if (sIdx > finalIdx) finalIdx = sIdx;
      }

      return {
        size: listRaw[finalIdx],
        straddleSize: null,
        clampLow: clampLow,
        clampHigh: clampHigh,
        tallApplied: tallApplied,
        largeApplied: largeApplied
      };
    }

    const parsed = {};
    Object.keys(D.guides).forEach((k) => { parsed[k] = parse(D.guides[k].data); });

    /* Op let: het re-entry-haakje hierboven leidt deze drie opnieuw af. */
    let advBands = parseWeightBands(D.advisor && D.advisor.weightTable);
    let advRunsLarge = String((D.advisor && D.advisor.runsLarge) || '')
      .split(/[\n,]+/).map((s) => s.trim().toLowerCase()).filter(Boolean);
    let advTall = parseFloat(D.advisor && D.advisor.tall) || 0;

    function variantId() {
      const scope = document.querySelector('.product__info-container') || document;
      const el = scope.querySelector('[name="id"]');
      if (el && el.value) return String(el.value);
      const u = new URLSearchParams(location.search).get('variant');
      return u ? String(u) : '';
    }

    function garment() {
      const hit = D.map[variantId()];
      return (hit && hit[0]) || D.fallback || 'tee';
    }

    /* Alleen de maten die dit product voor dit kledingstuk echt verkoopt. */
    function sizesFor(g) {
      const set = [];
      Object.keys(D.map).forEach((id) => {
        const v = D.map[id];
        if (v[0] !== g) return;
        const s = norm(v[1]);
        if (s && set.indexOf(s) === -1) set.push(s);
      });
      return set;
    }

    /* De kolommen waaruit de adviseur mag kiezen: de maten uit de maattabel
       van dit kledingstuk, en dan alleen de maten die er ook echt zijn.
       Staat XS wel in de tabel maar is die variant nooit aangemaakt, dan
       adviseren we hem niet. We houden de PLEK in de tabel erbij, want bij
       kinderen moeten we op diezelfde plek de EU-maat opzoeken. */
    function advCols() {
      const g = garment();
      const p = parsed[g];
      if (!p || !p.sizes.length) return [];
      const own = sizesFor(g);
      const cols = [];
      p.sizes.forEach((s, i) => {
        if (!own.length || own.indexOf(norm(s)) > -1) cols.push({ label: s, i: i });
      });
      if (!cols.length) p.sizes.forEach((s, i) => cols.push({ label: s, i: i }));
      return cols;
    }

    /* Namen zoals de tabel ze schrijft, want die zet de klant straks groot
       in beeld. */
    function advSizeListRaw() {
      return advCols().map((c) => c.label);
    }

    /* KINDEREN. Een EU-kindermaat IS de lichaamslengte: maat 116 hoort bij
       een kind tot ongeveer 116 cm. Staat die rij in de tabel, dan hebben we
       genoeg om op lengte te adviseren. Gewicht en pasvorm vragen we niet -
       daar koopt niemand een kindershirt op, en een kind van 8 weegt niet
       zoals een volwassene van dezelfde lengte. */
    function kidsEu() {
      const p = parsed[garment()];
      if (!p) return null;
      return p.rows['eu size'] || p.rows['eu maat'] || p.rows['eu'] || null;
    }

    /* Kindermodus alleen als dit kledingstuk EU-maten heeft EN geen enkele
       maat uit de gewichtsladder. Zo blijft de volwassen weg ongemoeid, ook
       als je later een kindertabel met S/M/L zou maken. */
    function isKidsMode() {
      if (!kidsEu()) return false;
      const list = advSizeListRaw().map(norm);
      if (!list.length) return false;
      return !advBands.some((b) => list.indexOf(norm(b.key)) > -1);
    }

    /* De kleinste maat waar het kind nog in past: de eerste EU-maat die
       groter of gelijk is aan zijn lengte. Is het kind groter dan de
       grootste maat, dan wordt het die grootste - en dat zeggen we erbij. */
    function computeAdviceKids(heightCm) {
      const cols = advCols();
      const eu = kidsEu();
      if (!cols.length || !eu || !(heightCm > 0)) return null;

      let pick = -1;
      let clampHigh = false;
      for (let n = 0; n < cols.length; n++) {
        const v = parseFloat(String(eu[cols[n].i]).replace(',', '.'));
        if (isNaN(v)) continue;
        if (heightCm <= v) { pick = n; break; }
      }
      if (pick === -1) { pick = cols.length - 1; clampHigh = true; }

      const first = parseFloat(String(eu[cols[0].i]).replace(',', '.'));
      const clampLow = !isNaN(first) && heightCm < first - 6;

      return {
        size: cols[pick].label,
        straddleSize: null,
        clampLow: clampLow,
        clampHigh: clampHigh,
        tallApplied: false,
        largeApplied: false
      };
    }

    function has() {
      const p = parsed[garment()];
      return !!(p && p.sizes.length && p.order.length);
    }

    function esc(s) {
      return String(s === undefined || s === null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function build(unit) {
      const g = garment();
      const guide = D.guides[g];
      const p = parsed[g];
      const own = sizesFor(g);

      const cols = [];
      p.sizes.forEach((s, i) => {
        if (!own.length || own.indexOf(norm(s)) > -1) cols.push({ label: s, i: i });
      });
      if (!cols.length) p.sizes.forEach((s, i) => cols.push({ label: s, i: i }));

      const conv = (v) => {
        const n = parseFloat(String(v).replace(',', '.'));
        if (isNaN(n)) return v;
        return unit === 'in' ? (n / 2.54).toFixed(1) : String(v);
      };

      let html = '<div class="rk-sg2-top"><p class="rk-sg2-sub">' + esc(guide.name) + '</p>';
      if (D.showUnits) {
        html += '<span class="rk-sg2-units">' +
          '<b data-u="cm" class="' + (unit === 'cm' ? 'is-on' : '') + '">' + esc(D.text.cm) + '</b>' +
          '<b data-u="in" class="' + (unit === 'in' ? 'is-on' : '') + '">' + esc(D.text.inch) + '</b>' +
          '</span>';
      }
      html += '</div>';

      if (guide.img) {
        html += '<div class="rk-sg2-draw"><img alt="" loading="lazy" src="' + esc(guide.img) + '"></div>';
      }

      html += '<div class="rk-sg2-scroll"><table class="rk-sg2-table"><thead><tr><th></th>';
      cols.forEach((c) => { html += '<th>' + esc(c.label) + '</th>'; });
      html += '</tr></thead><tbody>';

      p.order.forEach((key) => {
        const vals = p.rows[key];
        const label = D.rows[key] || p.labels[key];
        const isCm = CM_ROWS.indexOf(key) > -1;
        html += '<tr><th>' + esc(label) + '</th>';
        cols.forEach((c) => {
          const raw = vals[c.i];
          html += '<td>' + esc(raw === undefined ? '' : (isCm ? conv(raw) : raw)) + '</td>';
        });
        html += '</tr>';
      });

      html += '</tbody></table></div>';
      if (p.fit) html += '<p class="rk-sg2-fit">' + esc(p.fit) + '</p>';
      if (D.text.note) html += '<p class="rk-sg2-note">' + esc(D.text.note) + '</p>';
      return html;
    }

    /* Klein, generiek liniaal-icoontje - geen bestaand logo. */
    const RULER_SVG = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true" focusable="false">' +
      '<rect x="1.25" y="5" width="13.5" height="6" rx="1.2" stroke="currentColor" stroke-width="1.2"/>' +
      '<path d="M4 5v2.2M6.4 5v3.4M8.8 5v2.2M11.2 5v3.4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +
      '</svg>';

    /* Bouwt het uitkomst-blok: grote maat, uitlegzin, eventuele
       grensmelding, disclaimer, en daaronder altijd de gewone maattabel via
       build(), zodat wie het zeker wil weten kan meten. */
    function renderResult() {
      const adv = D.advisor || {};
      const kids = isKidsMode();

      /* Pas rekenen als de klant de rollen heeft aangeraakt. Anders zou er
         meteen een maat staan die hij nooit heeft ingevuld. Bij kinderen is
         er maar één rol, dus daar telt alleen de lengte. */
      if (kids ? !touchedH : (!touchedH || !touchedW)) return '';

      const res = kids ? computeAdviceKids(advHeightCm) : computeAdvice(advHeightCm, advWeightKg, advFit);
      if (!res) return '';

      const fitWord = advFit === 'tight' ? adv.fitTight : (advFit === 'loose' ? adv.fitLoose : adv.fitRegular);
      const shownH = advUnitH === 'cm'
        ? Math.round(advHeightCm) + ' cm'
        : (Math.floor(Math.round(advHeightCm / IN_CM) / 12) + "'" + (Math.round(advHeightCm / IN_CM) % 12) + '"');
      const shownW = advUnitW === 'kg'
        ? Math.round(advWeightKg) + ' kg'
        : (Math.round(advWeightKg / LB_KG) + ' lbs');

      /* De zin in de instellingen zegt "a height of [height] cm". De waarde
         die we invullen heeft de eenheid nu al bij zich (cm of 5'10"), dus
         die losse cm/kg halen we hier weg. Anders staat er "178 cm cm", of
         erger: "5'10" cm" zodra iemand op ponden staat. */
      const tmpl = String(adv.sentence || '')
        .replace('[height] cm', '[height]')
        .replace('[weight] kg', '[weight]');

      let text = kids
        ? fill(String(adv.kidsSentence || ''), { height: shownH })
        : fill(tmpl, { height: shownH, weight: shownW, fit: fitWord || '' });
      if (res.tallApplied && adv.noteTall) text += ' ' + fill(adv.noteTall, { tall: adv.tall });
      if (res.largeApplied && adv.noteLarge) text += ' ' + adv.noteLarge;
      if (res.clampLow && adv.noteClampLow) text += ' ' + adv.noteClampLow;
      if (res.clampHigh && adv.noteClampHigh) text += ' ' + adv.noteClampHigh;

      /* !! ALTIJD ÉÉN MAAT !!
         computeAdvice() geeft straddleSize niet meer terug - zit de klant
         tussen twee maten in, dan is de grootste van de twee daar al
         gekozen. Deze twee regels blijven staan voor het geval er ooit weer
         een tweede maat uit zou komen; dan valt het niet stil maar zie je
         het meteen. */
      let bigSize = res.size;
      let betweenHtml = '';
      if (res.straddleSize) {
        bigSize = res.size + ' / ' + res.straddleSize;
        if (adv.noteBetween) {
          const between = fill(adv.noteBetween, { size_a: res.size, size_b: res.straddleSize });
          betweenHtml = '<p class="rk-adv-between">' + esc(between) + '</p>';
        }
      }

      let html = '<div class="rk-adv-outcome">';
      if (adv.resultLabel) html += '<p class="rk-adv-outcome-label">' + esc(adv.resultLabel) + '</p>';
      html += '<p class="rk-adv-size">' + esc(bigSize) + '</p>';
      html += '<p class="rk-adv-sentence">' + esc(text) + '</p>';
      html += betweenHtml;
      if (adv.disclaimer) html += '<p class="rk-adv-disclaimer">' + esc(adv.disclaimer) + '</p>';
      html += '</div>';
      html += '<div class="rk-adv-table">' + build(unit) + '</div>';
      return html;
    }

    /* Het adviesscherm: lengte, gewicht, pasvorm - en daaronder live de
       uitkomst zodra er genoeg is ingevuld. */
    function renderAdvisor() {
      const adv = D.advisor || {};
      const kids = isKidsMode();
      let html = '<div class="rk-adv">';

      html += wheelHtml('height', kids ? (adv.kidsHeightLabel || adv.heightLabel) : adv.heightLabel);

      if (!kids) {
        html += wheelHtml('weight', adv.weightLabel);

        html += '<div class="rk-adv-field" style="margin-top:16px"><span class="rk-adv-label">' + esc(adv.fitLabel) + '</span><div class="rk-adv-fits">';
        [['tight', adv.fitTight], ['regular', adv.fitRegular], ['loose', adv.fitLoose]].forEach((pair) => {
          html += '<button type="button" class="rk-adv-fit' + (advFit === pair[0] ? ' is-on' : '') + '" data-fit="' + pair[0] + '">' + esc(pair[1]) + '</button>';
        });
        html += '</div></div>';
      }
      html += '<div class="rk-adv-result">' + renderResult() + '</div>';
      if (adv.guideButton) html += '<button type="button" class="rk-adv-guide-btn">' + esc(adv.guideButton) + '</button>';
      html += '</div>';
      return html;
    }

    let unit = 'cm';
    let advFit = 'regular';

    /* Binnen rekenen we ALTIJD in centimeters en kilo's; de rolkiezer laat
       alleen andere getallen zien. Zo hoeft computeAdvice() niets te weten
       van inches of ponden. */
    let advUnitH = 'cm';
    let advUnitW = 'kg';
    let advHeightCm = 178;
    let advWeightKg = 78;
    let touchedH = false;
    let touchedW = false;

    const IN_CM = 2.54;
    const LB_KG = 0.45359237;

    /* De waarden die in de rol staan, met hun weergave. Metrisch is gewoon
       het getal; imperiaal rekenen we om naar voet/inch en ponden. */
    function wheelValues(kind) {
      const out = [];
      if (kind === 'height') {
        /* Een kind begint bij 80 cm, een volwassene bij 140. Zonder dat
           onderscheid moet een ouder van een kleuter eindeloos naar links
           vegen, of kan hij er helemaal niet komen. */
        const kids = isKidsMode();
        if (advUnitH === 'cm') {
          for (let cm = (kids ? 80 : 140); cm <= (kids ? 185 : 210); cm++) {
            out.push({ v: cm, t: cm + ' cm', s: cm, major: cm % 10 === 0, mid: cm % 5 === 0 });
          }
        } else {
          for (let i = (kids ? 31 : 55); i <= (kids ? 73 : 83); i++) {
            const label = Math.floor(i / 12) + "'" + (i % 12) + '"';
            out.push({
              v: Math.round(i * IN_CM * 10) / 10,
              t: label,
              s: label,
              major: i % 12 === 0,
              mid: i % 6 === 0
            });
          }
        }
      } else {
        if (advUnitW === 'kg') {
          for (let kg = 40; kg <= 150; kg++) {
            out.push({ v: kg, t: kg + ' kg', s: kg, major: kg % 10 === 0, mid: kg % 5 === 0 });
          }
        } else {
          for (let lb = 88; lb <= 330; lb++) {
            out.push({ v: Math.round(lb * LB_KG * 10) / 10, t: lb + ' lbs', s: lb, major: lb % 20 === 0, mid: lb % 10 === 0 });
          }
        }
      }
      return out;
    }

    function nearestIndex(list, value) {
      let best = 0;
      let diff = Infinity;
      list.forEach((o, i) => {
        const d = Math.abs(o.v - value);
        if (d < diff) { diff = d; best = i; }
      });
      return best;
    }

    function wheelHtml(kind, label) {
      const adv2 = D.advisor || {};
      const list = wheelValues(kind);
      const idx = nearestIndex(list, kind === 'height' ? advHeightCm : advWeightKg);

      const isH = kind === 'height';
      const cur = isH ? advUnitH : advUnitW;
      const unitOpts = isH
        ? [['cm', adv2.unitCm || 'CM'], ['ft', adv2.unitFt || 'FT']]
        : [['kg', adv2.unitKg || 'KG'], ['lb', adv2.unitLb || 'LBS']];

      let toggle = '<span class="rk-adv-units">';
      unitOpts.forEach((o) => {
        toggle += '<b class="' + (cur === o[0] ? 'is-on' : '') + '" data-au="' + kind + ':' + o[0] + '">' + esc(o[1]) + '</b>';
      });
      toggle += '</span>';

      let html = '<div class="rk-adv-ruler-field">' +
        '<div class="rk-adv-ruler-top"><span class="rk-adv-label">' + esc(label) + '</span>' + toggle + '</div>' +
        '<div class="rk-adv-valuewrap"><span class="rk-adv-value" data-value="' + kind + '">' + esc(list[idx].t) + '</span></div>' +
        '<div class="rk-adv-rulerwrap">' +
        '<span class="rk-adv-needle" aria-hidden="true"></span>' +
        '<div class="rk-adv-ruler" data-wheel="' + kind + '"><ul class="rk-adv-ticks">';

      list.forEach((o, i) => {
        let cls = 'rk-adv-tick';
        if (o.major) cls += ' rk-adv-tick--major';
        else if (o.mid) cls += ' rk-adv-tick--mid';
        html += '<li class="' + cls + (i === idx ? ' is-on' : '') + '" data-i="' + i + '" data-v="' + o.v + '" data-t="' + esc(o.t) + '">';
        if (o.major) html += '<span class="rk-adv-ticklabel">' + esc(o.s) + '</span>';
        html += '</li>';
      });

      html += '</ul></div></div></div>';
      return html;
    }

    function open(view) {
      if (document.querySelector('.rk-sg-modal')) return;
      const modal = document.createElement('div');
      modal.className = 'rk-sg-modal';
      modal.innerHTML =
        '<div class="rk-sg-panel" role="dialog" aria-modal="true">' +
        '<div class="rk-sg-head"><h2></h2>' +
        '<button class="rk-sg-close" type="button">&times;</button>' +
        '</div><div class="rk-sg-body"></div></div>';

      const panel = modal.querySelector('.rk-sg-panel');
      panel.querySelector('.rk-sg-close').setAttribute('aria-label', D.text.close || 'Close');

      const body = panel.querySelector('.rk-sg-body');

      /* 'guide' = de gewone maattabel, 'advisor' = het adviesscherm. */
      let currentView = (view === 'advisor' && D.advisor && D.advisor.enabled) ? 'advisor' : 'guide';

      /* Bij een kinderartikel begint de rol op 120 cm in plaats van op de
         178 cm van een volwassene - anders staat hij meteen aan het eind. */
      if (isKidsMode() && !touchedH) advHeightCm = 120;

      const render = () => {
        panel.querySelector('h2').textContent =
          (currentView === 'advisor' && D.advisor && D.advisor.heading) ? D.advisor.heading : D.text.heading;
        body.innerHTML = currentView === 'advisor' ? renderAdvisor() : build(unit);
        if (currentView === 'advisor') initWheels(body);
      };

      /* De rollen op de goede stand zetten en luisteren naar het scrollen.
         Tijdens het scrollen bouwen we de adviseur NIET opnieuw op - dat zou
         de rol onder je vinger vandaan trekken. Alleen de uitkomst ververst. */
      function initWheels(scope) {
        scope.querySelectorAll('[data-wheel]').forEach((ruler) => {
          const kind = ruler.getAttribute('data-wheel');
          const ticks = Array.from(ruler.querySelectorAll('.rk-adv-tick'));
          if (!ticks.length) return;

          const step = 10;
          const valueEl = scope.querySelector('[data-value="' + kind + '"]');
          const start = ticks.findIndex((o) => o.classList.contains('is-on'));

          /* !! WAAROM DE LINIAAL NOOIT AAN HET EINDE KWAM !!
             De hoogste waarde die je kon bereiken was 193 cm in plaats van
             210, 133 kg in plaats van 150, 5'5" in plaats van 6'11" en 312
             lbs in plaats van 330. Elke keer bleef er precies een half
             scherm aan streepjes onbereikbaar.

             Het eerste en het laatste streepje moeten allebei tot MIDDEN
             onder de naald kunnen komen, dus staat er links en rechts een
             half scherm lucht. Die lucht stond als percentage-padding op de
             <ul>. Links werkt dat, maar de padding RECHTS van een
             flex-container telt de browser niet mee in de scrollbreedte -
             een oude en bekende eigenaardigheid. Gevolg: je kon precies een
             half scherm te weinig doorschuiven.

             Daarom is de lucht rechts nu een ECHT element (een leeg li'tje)
             in plaats van padding. Let op: dat li'tje heeft ook HOOGTE nodig
             - die staat in assets/rk-sg-modal.css. Een vlak van nul bij nul
             telt namelijk net zo min mee als padding. Links blijft het
             padding, want daar gaat het wel goed, en dan hoeft de rekensom
             in place() hieronder niet te veranderen: streepje i komt onder
             de naald bij scrollLeft = i * step.

             De maat wordt in pixels gezet en niet in procenten, want een
             percentage op een flex-item rekent tegen de INHOUD van de rij
             (duizenden pixels breed), niet tegen het venster. */
          const list = ruler.querySelector('.rk-adv-ticks');
          const pad = Math.max(0, Math.round(ruler.clientWidth / 2 - step / 2));
          if (list && pad > 0) {
            list.style.paddingLeft = pad + 'px';
            list.style.paddingRight = '0px';

            let spacer = list.querySelector('.rk-adv-spacer');
            if (!spacer) {
              spacer = document.createElement('li');
              spacer.className = 'rk-adv-spacer';
              spacer.setAttribute('aria-hidden', 'true');
              list.appendChild(spacer);
            }
            spacer.style.flex = '0 0 ' + pad + 'px';
          }

          /* !! WAAROM DE LINIAAL ALTIJD HELEMAAL LINKS BEGON !!
             Boven de liniaal stond 178 cm, maar de naald stond bij 140 - het
             allereerste streepje. En bij gewicht stond er 78 kg terwijl de
             naald bij 40 stond.

             Oorzaak: render() draaide voordat het venster in de pagina hing.
             Een element dat niet in de pagina staat heeft geen breedte, dus
             heeft deze scroller ook geen scrollbereik: scrollLeft = 380
             wordt dan gewoon 0. Daarna werd de stand nooit meer
             gecorrigeerd, dus bleef de liniaal voor altijd op zijn eerste
             streepje staan.

             Daarom hangt het venster nu AL in de pagina voordat render()
             draait - zie onderaan open(). */
          const place = () => { ruler.scrollLeft = Math.max(start, 0) * step; };
          place();
          window.requestAnimationFrame(place);

          /* De waarde onder de naald aflezen. Alleen het cijfer boven de
             liniaal en de uitkomst worden ververst - het hele adviesscherm
             opnieuw opbouwen zou de liniaal onder je duim vandaan trekken. */
          const settle = () => {
            const i = Math.max(0, Math.min(ticks.length - 1, Math.round(ruler.scrollLeft / step)));
            ticks.forEach((o, n) => o.classList.toggle('is-on', n === i));
            const v = parseFloat(ticks[i].getAttribute('data-v'));
            if (kind === 'height') { advHeightCm = v; touchedH = true; }
            else { advWeightKg = v; touchedW = true; }
            if (valueEl) valueEl.textContent = ticks[i].getAttribute('data-t');
            const resultEl = body.querySelector('.rk-adv-result');
            if (resultEl) resultEl.innerHTML = renderResult();
          };

          let t = 0;
          ruler.addEventListener('scroll', () => {
            window.clearTimeout(t);
            t = window.setTimeout(settle, 80);
          });

          ticks.forEach((o, i) => {
            o.addEventListener('click', () => {
              ruler.scrollTo({ left: i * step, behavior: 'smooth' });
              window.setTimeout(settle, 260);
            });
          });

          /* Slepen met de muis. Op een telefoon veeg je gewoon; op een
             desktop verwacht niemand een zijwaartse scrollbalk, dus daar
             pak je de liniaal met de muis vast. */
          let down = false, startX = 0, startLeft = 0;
          ruler.addEventListener('mousedown', (e) => {
            down = true; startX = e.clientX; startLeft = ruler.scrollLeft;
            ruler.style.cursor = 'grabbing';
            e.preventDefault();
          });
          window.addEventListener('mousemove', (e) => {
            if (!down) return;
            ruler.scrollLeft = startLeft - (e.clientX - startX);
          });
          window.addEventListener('mouseup', () => {
            if (!down) return;
            down = false;
            ruler.style.cursor = 'grab';
            window.setTimeout(settle, 60);
          });
        });
      }

      const close = () => {
        modal.classList.remove('is-open');
        window.setTimeout(() => modal.remove(), 260);
        document.removeEventListener('keydown', onKey);
      };

      function onKey(e) { if (e.key === 'Escape') close(); }

      modal.addEventListener('click', (e) => {
        const u = e.target.closest && e.target.closest('[data-u]');
        if (u) { unit = u.getAttribute('data-u'); render(); return; }

        const au = e.target.closest && e.target.closest('[data-au]');
        if (au) {
          const parts = String(au.getAttribute('data-au')).split(':');
          if (parts[0] === 'height') advUnitH = parts[1];
          else advUnitW = parts[1];
          render();
          return;
        }

        const fitBtn = e.target.closest && e.target.closest('.rk-adv-fit');
        if (fitBtn) { advFit = fitBtn.getAttribute('data-fit'); render(); return; }

        const guideBtn = e.target.closest && e.target.closest('.rk-adv-guide-btn');
        if (guideBtn) { currentView = 'guide'; render(); return; }

        if (e.target === modal || e.target.classList.contains('rk-sg-close')) close();
      });

      document.addEventListener('keydown', onKey);

      /* !! DEZE VOLGORDE IS DE FIX VAN DE LINIAAL - NIET OMDRAAIEN !!
         Het venster gaat EERST in de pagina en wordt DAARNA gevuld. Stond
         appendChild hieronder na render(), dan bouwde initWheels() zijn
         rollen op in een element zonder breedte: scrollLeft bleef 0 en de
         lucht rechts kon niet worden uitgerekend. Zolang het venster nog
         geen is-open heeft is het volledig doorzichtig en vangt het geen
         klikken, dus de bezoeker ziet van deze volgorde niets. */
      document.body.appendChild(modal);
      render();
      requestAnimationFrame(() => modal.classList.add('is-open'));
    }

    window.RK_SG = { open: open, has: has, garment: garment };

    /* Op let: het re-entry-haakje hierboven leidt deze opnieuw af. */
    let titles = String(D.text.guideTitles || 'size guide')
      .toLowerCase().split(',').map((x) => x.trim()).filter(Boolean);

    function isGuideTitle(el) {
      const t = (el.textContent || '').trim().toLowerCase();
      if (t.length > 40) return false;
      return titles.some((g) => t.indexOf(g) > -1);
    }

    /* Zowel de link op de maatregel als de accordeon onderaan de pagina
       openen dit venster. De adviseurknop opent hetzelfde venster, maar
       meteen op het adviesscherm. Capture-fase met stopImmediatePropagation,
       zodat een oudere klikafhandelaar van een andere sectie er niet
       overheen kan. */
    document.addEventListener('click', (e) => {
      if (!e.target.closest) return;
      const link = e.target.closest('.rk-sg-link');
      const advisorBtn = e.target.closest('.rk-sg-advisor-btn');
      const summary = e.target.closest('summary');
      const hit = link || advisorBtn || (summary && isGuideTitle(summary) ? summary : null);
      if (!hit || !has()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open(advisorBtn ? 'advisor' : 'guide');
    }, true);

    /* Het plaatsen van de LINK en van de ADVISEURKNOP zijn twee losse
       stappen - zie de waarschuwing bovenaan dit bestand.

       !! DE KNOP MOET IN HET HUIDIGE VARIANTENBLOK STAAN - NIET ZOMAAR
          ERGENS OP DE PAGINA !!
       Hier stond `if (document.querySelector('.rk-sg-advisor-btn')) return;`
       en dat was precies de bug die het "wegspringen" veroorzaakte.

       Shopify vervangt het variantenblok bij een kleur- of maatklik niet
       netjes: het zet een NIEUW <variant-selects> neer en laat het oude nog
       een halve seconde staan. Gemeten, na een kleurklik:

           313 ms   nieuw blok erbij, zonder onze knop -> kolom 1442 -> 1408
           934 ms   onze knop verhuisd naar het nieuwe blok -> weer 1442
          1081 ms   Shopify ruimt het oude blok op

       620 milliseconden lang was de kolom dus 34px korter, en dat is de
       sprong die je onder de prijs ziet. De controle hierboven vond de knop
       namelijk in dat oude blok en concludeerde "hij staat er al".

       Daarom wordt er nu eerst opgeruimd: elke adviseurknop of Size
       Guide-link die niet bij de HUIDIGE maatregel hoort gaat eruit, en pas
       daarna wordt er geplaatst. Zo kan er per definitie maar een staan, en
       altijd op de goede plek. */
    function ensureLink() {
      if (!has()) return;

      const scope = document.querySelector('.product__info-container');
      if (!scope) return;

      const names = String(D.text.sizeNames || 'size, maat, taille, talla, taglia, tamanho')
        .toLowerCase().split(',').map((x) => x.trim()).filter(Boolean);

      const label = Array.from(scope.querySelectorAll('legend, .form__label')).find((x) => {
        const t = x.textContent.trim().toLowerCase();
        return names.some((n) => t.indexOf(n) === 0);
      });
      if (!label) return;

      const block = label.closest('fieldset, .product-form__input, .product-form__controls');

      /* Opruimen. "Goed" is: de knop staat direct voor het maatblok (stand
         "boven") of binnen het label zelf (stand "naast de link"). Al het
         andere is een restant uit een blok dat niet meer meedoet. */
      document.querySelectorAll('.rk-sg-advisor-btn').forEach((el) => {
        const goed = (block && el.nextElementSibling === block) || label.contains(el);
        if (!goed) el.remove();
      });
      document.querySelectorAll('.rk-sg-link').forEach((el) => {
        if (!label.contains(el)) el.remove();
      });

      /* Stap 1: de Size Guide-link, alleen als niemand anders er al een
         heeft neergezet op DEZE maatregel. */
      let link = label.querySelector('.rk-sg-link');
      if (!link) {
        link = document.createElement('button');
        link.type = 'button';
        link.className = 'rk-sg-link';
        link.textContent = D.text.linkLabel || D.text.heading;
        label.appendChild(link);
      }

      /* Stap 2: de adviseurknop. Los van stap 1. */
      if (!D.advisor || !D.advisor.enabled || !D.advisor.label) return;
      if (document.querySelector('.rk-sg-advisor-btn')) return;

      const advBtn = document.createElement('button');
      advBtn.type = 'button';
      advBtn.className = 'rk-sg-advisor-btn';
      advBtn.innerHTML = RULER_SVG + '<span>' + esc(D.advisor.label) + '</span>';

      if (D.advisor.position === 'inline' && link && link.parentNode) {
        advBtn.classList.add('rk-sg-advisor-btn--inline');
        link.parentNode.insertBefore(advBtn, link.nextSibling);
        return;
      }

      advBtn.classList.add('rk-sg-advisor-btn--above');

      if (block && block.parentNode) block.parentNode.insertBefore(advBtn, block);
      else if (label.parentNode) label.parentNode.insertBefore(advBtn, label);
      else label.appendChild(advBtn);
    }

    window.setTimeout(ensureLink, 900);
    window.setTimeout(ensureLink, 2200);

    /* !! HIER GING HET MIS - ZIE DE TWEEDE WAARSCHUWING BOVENAAN !!
       De waarnemer werd één keer aangehaakt, op het moment dat dit script
       draait. Deze sectie zit in de HEADER-groep, dus toen bestond
       .product__info-container nog niet: querySelector gaf null en de
       waarnemer werd overgeslagen. Gevolg: de knop kwam na de eerste
       variantklik niet meer terug. Nu blijven we het proberen tot de
       rechterkolom er is.

       !! GEEN POORT MEER VOOR ensureLink() - DAT WAS DE TWEEDE SPRONG !!
       Hier stond een snelle controle die eerst keek of de knop er nog was,
       om ensureLink() niet bij elke wijziging te hoeven draaien. Elke vorm
       van zo'n controle bleek te grof: zolang het OUDE variantenblok nog
       naast het nieuwe stond, leek er niets aan de hand en gebeurde er
       niets - 620 ms lang, met een 34px kortere kolom als gevolg.

       ensureLink() draait daarom nu bij ELKE wijziging in de rechterkolom.
       Dat mag: hij zoekt een handvol legends op, kijkt of de knop op de
       goede plek staat en doet in verreweg de meeste gevallen niets. En
       omdat een MutationObserver-callback als microtaak draait - dus VOOR
       het tekenen - is er geen enkel beeld waarin de knop weg is.

       `busy` voorkomt dat onze eigen invoeging de waarnemer opnieuw aan het
       werk zet; de timer eronder blijft als vangnet staan voor het geval
       een app het blok een fractie later alsnog verbouwt. */
    function watchInfo() {
      const scope = document.querySelector('.product__info-container');
      if (!scope || !window.MutationObserver) return false;

      let t = 0;
      let busy = false;

      new MutationObserver(() => {
        if (busy) return;

        busy = true;
        try {
          ensureLink();
        } finally {
          busy = false;
        }

        window.clearTimeout(t);
        t = window.setTimeout(ensureLink, 150);
      }).observe(scope, { childList: true, subtree: true });

      return true;
    }

    if (!watchInfo()) {
      let tries = 0;
      const iv = window.setInterval(() => {
        tries += 1;
        if (watchInfo() || tries > 60) window.clearInterval(iv);
      }, 150);
    }

    /* Vangnet: de maatkiezers vuren een change op het document. Ook als de
       waarnemer om wat voor reden dan ook niets ziet, staat de knop daarna
       weer terug. ensureLink() controleert zelf of hij er al is, dus dit
       kan geen lus worden. */
    document.addEventListener('change', () => window.setTimeout(ensureLink, 200));
  })();
